import React, { useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

const packList = [
  {
    id: 'original',
    url: getImageFromS3('images/kv6/original.png')
  },
  {
    id: 'blue',
    url: getImageFromS3('images/kv6/blue.png')
  },
  {
    id: 'compact-blue',
    url: getImageFromS3('images/kv6/compact-blue.png')
  },
  {
    id: 'compact-silver',
    url: getImageFromS3('images/kv6/compact-silver.png')
  }
];

const HomeScreen = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div
          className={styles.firstContent}
          style={{
            backgroundImage: `url(${getImageFromS3('images/kv6/first-bg.png')})`
          }}
        >
          <img
            src={getImageFromS3('images/kv6/logo.png')}
            className={styles.logo}
            alt="logo"
          />
          <div className={styles.carousel}>
            <Swiper
              slidesPerView={1.4}
              spaceBetween={15}
              centeredSlides={true}
              pagination={{
                clickable: true
              }}
              modules={[Pagination]}
              className="mySwiper"
              onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
            >
              {packList?.map((item, index) => {
                return (
                  <SwiperSlide>
                    <img
                      src={item?.url}
                      alt={item?.id}
                      className={styles.packItem}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
        <div className={styles.disclaimer}>
          *зазначено задекларовану максимальну роздрібну ціну з урахуванням
          акцизного податку на роздрібний продаж тютюнових виробів станом на
          липень 2025 року
        </div>
        <div
          className={styles.secondContent}
          style={{
            backgroundImage: `url(${getImageFromS3(
              'images/kv6/second-bg.png'
            )})`
          }}
        >
          <div className={styles.tobaccoContainer}>
            <img src={getImageFromS3('images/kv6/tobacco.png')} alt="tobacco" />
          </div>
          <div className={styles.quizContainer}>
            <img src={getImageFromS3('images/kv6/quiz-bg.png')} alt="quiz-bg" />
            <p className={styles.title}>
              Хочеш отримувати новини <br></br> про цю продукцію?
            </p>
            <p className={styles.subTitle}>
              Проходь невелике опитування<br></br> та <b>отримуй 30 грн</b> на
              мобільний<br></br> за витрачений час
            </p>
            <button
              onClick={() => {
                window.location.href =
                  'https://www.scanpack.com/ua-reg?utm_campaign=25UA-KV6&returned=true';
              }}
            >
              Пройти опитування
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
